/**
 * The Overview's open drill-down, as the URL's `view` parameter writes it:
 * attention:<bucket> (one of lib/derive's BUCKETS), engaged, or documents
 * with an optional :<filter> (one of lib/documents' DOCUMENT_FILTERS; plain
 * "documents" is everyone). Anything else is no drill-down, so a stale or
 * hand-edited link shows the Overview rather than an empty page.
 */
import { isBucket } from './derive';
import { DEFAULT_DOCUMENT_FILTER, isDocumentFilter } from './documents';

export function parseView(raw) {
  if (raw === 'engaged') return { kind: 'engaged' };
  if (raw === 'documents') return { kind: 'documents', filter: DEFAULT_DOCUMENT_FILTER };
  const documents = /^documents:(.+)$/.exec(raw || '');
  if (documents && isDocumentFilter(documents[1])) return { kind: 'documents', filter: documents[1] };
  const match = /^attention:(.+)$/.exec(raw || '');
  if (match && isBucket(match[1])) return { kind: 'attention', bucket: match[1] };
  return null;
}

export const attentionView = (bucket) => `attention:${bucket}`;

/** The documents view on `filter`; everyone is plain "documents". */
export const documentsView = (filter = DEFAULT_DOCUMENT_FILTER) => (
  filter === DEFAULT_DOCUMENT_FILTER ? 'documents' : `documents:${filter}`);
